import { Link } from 'react-router-dom';
import { principles, testimonials } from '@/mocks/site';
import SectionHeading from '@/components/base/SectionHeading';

export default function VoicesSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="同学口碑"
          title="他们这样围观，也这样记录"
          desc="来自不同高校的同学，说说他们为什么愿意把身边的事写下来。"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl leading-none text-primary-300" aria-hidden="true"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.name} 头像`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="flex flex-col">
                  <strong className="text-sm font-semibold text-foreground-950">{item.name}</strong>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-12 rounded-lg bg-accent-50 p-6 md:mt-16 md:p-10">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-xs font-semibold tracking-[0.24em] text-accent-800">我们怎么做事</p>
              <h3 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
                四条内容原则，写进每一次更新里
              </h3>
            </div>
            <Link
              to="/about"
              className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
            >
              看看关于我们
              <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
            </Link>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {principles.map((item) => (
              <div key={item.title} className="rounded-lg bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${item.icon} text-lg leading-none`} aria-hidden="true"></i>
                </span>
                <h4 className="mt-3.5 font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}